module.exports = __webpack_public_path__ + "static/media/Location-icon.f6d81a3c.svg";